export const set = property => (state, payload) => (state[property] = payload)

export const toggle = property => state => (state[property] = !state[property])



// WEBPACK FOOTER //
// ./src/utils/vuex.js